import { UnleashClient } from "unleash-proxy-client";

const unleash = new UnleashClient({
  url: process.env.REACT_APP_UNLEASH_API_URL as string,
  clientKey: process.env.REACT_APP_UNLEASH_TOKEN as string,
  appName: process.env.REACT_APP_UNLEASH_TOKEN_NAME as string,
});

unleash.on("ready", () => {
  console.log("Unleash client ready");
});

// unleash.start();
export default unleash;
